import React from "react";
import "./scss/manager-market-card.scss";
import ApiImage from "./ApiImage";

export default function ManagerMarketCard({ market, onClick }) {
  const photos = market.photos || [];

  const leftPhoto = photos[0];
  const rightTop = photos[1];
  const rightBottom = photos[2];

  return (
    <div className="manager-market-card" onClick={onClick}>
      
      {/* PHOTOS GRID */}
      <div className="manager-market-card__photos">
        <div className="manager-market-card__left">
          {leftPhoto && <ApiImage src={leftPhoto} alt="" />}
        </div>

        <div className="manager-market-card__right">
          {rightTop && <ApiImage className="border-up" src={rightTop} alt="" />}
          {rightBottom && <ApiImage src={rightBottom} alt="" />}
        </div>
      </div>

      {/* INFO */}
      <div className="manager-market-card__info">
        <div className="manager-market-card__top">
          <div className="manager-market-card__name">
            {market.name}
          </div>

          <div className="manager-market-card__rating">
            ⭐ {(market.rating ?? 0).toFixed(2)}
          </div>
        </div>

        <div className="manager-market-card__bottom">
          <div>{market.city || "—"}</div>
          <div>{market.productCount ?? 0} товаров</div>
        </div>
      </div>
    </div>
  );
}
